import type { GameTranslation } from './game-en.ts';

/** Testi italiani delle schermate di gioco. Tipati sulla forma inglese: chiavi identiche. */
export const gameIt: GameTranslation = {
  setup: {
    you: 'Tu',
    soloTitle: 'Colpo in solitaria',
    soloIntro: 'Tu e i bot. Sei sempre un ladro; la Talpa, se c’è, è un bot.',
    players: 'Giocatori',
    playersOption: '{{count}} giocatori',
    map: 'Il colpo',
    difficulty: 'Difficoltà',
    infiltrator: 'La Talpa',
    infiltratorOptions: { never: 'Spenta', always: 'Sempre', normal: 'A sorte' },
    infiltratorHint: {
      never: 'Nessuno rema contro di te.',
      always: 'Uno dei bot è la Talpa.',
      normal: 'Forse, come online: 40 %, 55 % o 70 % con 3, 4 o 5 giocatori.',
    },
    role: 'Il tuo ruolo',
    roleRandom: 'A caso',
    botLevel: 'Livello dei bot',
    botLevels: {
      auto: 'Secondo la difficoltà',
      easy: 'Facile',
      medium: 'Medio',
      hard: 'Difficile',
      expert: 'Esperto',
    },
    start: 'Inizia il colpo',
  },
  game: {
    you: 'tu',
    hud: {
      leave: 'Lascia il colpo',
      timer: 'Tempo rimasto',
      alarm: 'Allarme',
      faster: 'orologio al {{pct}} %',
      pause: 'Pausa',
      resume: 'Riprendi',
    },
    pause: {
      title: 'In pausa',
      body: 'L’orologio e i bot sono fermi.',
      leave: 'Esci',
      resume: 'Torna al lavoro',
    },
    leave: {
      title: 'Lasciare il colpo?',
      body: 'Il colpo è perso e non viene salvato nulla.',
      stay: 'Resto',
      confirm: 'Esco',
    },
    phase: {
      briefing: 'Briefing',
      planning: 'Pianificazione',
      execution: 'Il colpo',
      escape: 'La fuga',
      hideout: 'Il covo',
      reveal: 'La rivelazione',
      ended: 'La rivelazione',
    },
    difficulty: { easy: 'Facile', normal: 'Normale', pro: 'Professionista', legend: 'Leggenda' },
    roles: {
      mastermind: 'Mente',
      locksmith: 'Scassinatore',
      hacker: 'Hacker',
      lookout: 'Palo',
      driver: 'Autista',
    },
    roleInfo: {
      mastermind: {
        sees: 'La pianta completa: stanze, pattuglie, telecamere, quanto durerà ogni stanza.',
        does: 'Propone il piano, guida la squadra, tiene le altezze della serratura e il profilo del proprietario della cassaforte.',
        powers: 'Due Piani B: annullano l’ultimo errore e il suo allarme.',
      },
      locksmith: {
        sees: 'Solo la stanza in cui ti trovi.',
        does: 'Scassina serrature e casseforti, gira gli specchi del laser.',
        powers: 'Nessuno. Gli attrezzi sono le tue mani.',
      },
      hacker: {
        sees: 'Terminali, rete, cablaggi.',
        does: 'Quadri elettrici, password, telecamere, anteprima del laser; guida la fuga in tre o quattro.',
        powers: 'Tre Loop: per 20 secondi le telecamere non contano.',
      },
      lookout: {
        sees: 'Il radar delle guardie, in tempo reale.',
        does: 'Tiene il percorso delle guardie e il manuale del quadro. Attraversa i corridoi con gli altri.',
        powers: 'Due Monete e un Petardo per attirare le guardie.',
      },
      driver: {
        sees: 'La radio della polizia.',
        does: 'Guida la fuga e passa agli altri i bollettini radio.',
        powers: 'Nessuno. Gli attrezzi sono le tue orecchie.',
      },
    },
    maps: {
      bank: {
        name: 'La Banca del Notturno',
        place: 'Milano, anni ’60. Una banca liberty, un caveau sotto la strada.',
        special: 'Nessuna regola speciale.',
      },
      museum: {
        name: 'Il Museo delle Maschere',
        place: 'Venezia, notte di Carnevale. La festa nasconde molte cose.',
        special: 'Ballo in maschera: al piano nobile le guardie vedono una casella in meno.',
      },
      villa: {
        name: 'La Villa sulla Scogliera',
        place: 'La Costiera, un collezionista eccentrico e i suoi congegni.',
        special: 'Meno guardie nei corridoi, più congegni nelle stanze.',
      },
      express: {
        name: 'L’Espresso delle Alpi',
        place: 'Un treno notturno. Il caveau è il vagone postale blindato.',
        special:
          'Timer ×0,8. Ogni 90 secondi una galleria: radar, radio e telecamere tacciono per 10.',
      },
    },
    rooms: {
      bank: {
        skylight: 'Lucernario',
        directorOffice: 'Ufficio del Direttore',
        archive: 'Archivio',
        gallery: 'Galleria Liberty',
        atrium: 'Atrio delle Vetrate',
        tellers: 'Sportelli',
        serviceYard: 'Cortile di Servizio',
        countingRoom: 'Sala Conta',
        powerRoom: 'Centrale Elettrica',
        armoredCorridor: 'Corridoio Blindato',
        safeDeposit: 'Cassette di Sicurezza',
        vault: 'Caveau',
        sewerTunnel: 'Cunicolo Fognario',
      },
      museum: {
        attic: 'Abbaino',
        costumeLoft: 'Soffitta dei Costumi',
        maskRoom: 'Sala delle Maschere',
        ballroom: 'Salone da Ballo',
        portraitGallery: 'Galleria dei Ritratti',
        grandStair: 'Scalone d’Onore',
        ticketOffice: 'Biglietteria',
        serviceLane: 'Calle di Servizio',
        restorationLab: 'Laboratorio di Restauro',
        controlRoom: 'Centralina',
        treasureCrypt: 'Cripta del Tesoro',
        undergroundCanal: 'Canale Sotterraneo',
        jewelRoom: 'Sala dei Gioielli',
      },
      villa: {
        terrace: 'Terrazza Panoramica',
        greenhouse: 'Serra',
        wonderSalon: 'Salotto delle Meraviglie',
        library: 'Biblioteca',
        collectorStudy: 'Studio del Collezionista',
        statueGallery: 'Galleria delle Statue',
        kitchen: 'Cucina e Dispensa',
        serviceEntrance: 'Ingresso di Servizio',
        cellar: 'Cantina',
        controlRoom: 'Sala Quadri',
        rarityVault: 'Camera Blindata delle Rarità',
        seaCave: 'Grotta Marina',
        stampRoom: 'Sala dei Francobolli',
      },
      express: {
        tailPlatform: 'Piattaforma di Coda',
        sleeper: 'Carrozza Letto',
        panoramaCar: 'Salone Panoramico',
        diningCar: 'Vagone Ristorante',
        baggageCar: 'Bagagliaio',
        mailCar: 'Vagone Postale Blindato',
        sleeperRoof: 'Tetto del Salone',
        diningRoof: 'Tetto del Ristorante',
        baggageRoof: 'Tetto del Bagagliaio',
        kitchen: 'Cucina',
        conductorCab: 'Cabina del Capotreno',
        undercarriage: 'Carrello sotto il Vagone',
        presidentialCabin: 'Cabina Presidenziale',
      },
    },
    entrances: {
      roof: { name: 'Tetto', effect: 'Nessun allarme. Il timer parte più corto di 60 secondi.' },
      sewer: {
        name: 'Fogne',
        effect: 'Nessun allarme. Il primo rompicapo è di un livello più difficile.',
      },
      service: {
        name: 'Porta di servizio',
        effect: 'L’allarme parte dal 10 %. Il primo rompicapo è di un livello più facile.',
      },
    },
    gear: {
      proPick: { name: 'Grimaldello pro', effect: 'Una serratura ha un perno in meno.' },
      jammer: { name: 'Jammer', effect: 'Spegne le telecamere di una stanza.' },
      rope: { name: 'Corda', effect: 'Permette un salto a fune tra due piani.' },
      disguise: {
        name: 'Travestimento',
        effect: 'La prima volta che una guardia vi vede, niente allarme.',
      },
      drone: { name: 'Drone', effect: 'Per 30 secondi tutti vedono la stanza successiva.' },
      emp: { name: 'Kit EMP', effect: 'Risolve un quadro elettrico.' },
    },
    puzzles: {
      lock: {
        name: 'Serratura a perni',
        short: 'Serr.',
        goal: 'Imposta i perni nell’ordine giusto, ognuno all’altezza giusta. L’ordine è sul terminale dell’Hacker, le altezze sulla pianta della Mente.',
      },
      safe: {
        name: 'Cassaforte',
        short: 'Cass.',
        goal: 'Trova la combinazione. Il profilo del proprietario la restringe; la cassaforte risponde a ogni tentativo con clic (cifra giusta al posto giusto) e ronzii (cifra giusta al posto sbagliato).',
      },
      panel: {
        name: 'Quadro elettrico',
        short: 'Quadro',
        goal: 'Taglia o collega ogni cavo come dice il manuale. Il manuale non è sul tuo schermo.',
      },
      cameras: {
        name: 'Telecamere',
        short: 'Tele.',
        goal: 'Gira ogni telecamera lontano dal percorso delle guardie, poi lancia il controllo. Il percorso è sullo schermo di un altro.',
      },
      laser: {
        name: 'Griglia laser',
        short: 'Laser',
        goal: 'Porta il raggio al ricevitore senza toccare la teca. Lo Scassinatore gira gli specchi; l’Hacker vede il raggio.',
      },
      password: {
        name: 'Password',
        short: 'Pass',
        goal: 'Scegli la parola giusta. Gli indizi sono sparsi tra gli altri.',
      },
      corridor: {
        name: 'Corridoio sorvegliato',
        short: 'Corr.',
        goal: 'Tutti fanno un passo, poi si muovono le guardie. Porta ogni pedina all’uscita senza farti vedere.',
      },
      escape: {
        name: 'Fuga',
        short: 'Fuga',
        goal: 'Fai scorrere i blocchi per liberare l’auto della fuga (★) verso il bordo destro. Le auto della polizia sbarrano la strada.',
      },
      vault: {
        name: 'Codice del caveau',
        short: 'Caveau',
        goal: 'Cinque simboli; ognuno di voi ne conosce uno o due. Inseriteli, poi tutti confermano. Un terzo codice errato blocca il caveau per sempre.',
      },
    },
    planProblem: {
      noEntrance: 'Scegli prima un ingresso.',
      noVault: 'Il percorso deve finire nel caveau.',
      tooShort: 'Un percorso ha almeno quattro stanze.',
      needRope: 'Il salto a fune richiede la Corda nel kit.',
      budget: 'Il kit costa più del budget.',
      other: 'Questo non è ancora un piano valido.',
    },
    briefing: {
      yourRole: 'Il tuo ruolo',
      sees: 'Vedi',
      does: 'Fai',
      powers: 'Poteri',
      secret: 'Segreto',
      stamp: 'Infiltrato',
      infiltratorBody:
        'Sei la Talpa. Vinci se il colpo fallisce, o se gli altri non ti votano fuori. Puoi sabotare tre volte, e mentire. Non fare il furbo.',
      coverBody: 'Una carta coperta. Uno di voi può lavorare contro la squadra. O nessuno.',
      target: 'Il bersaglio',
      loot: 'Bottino {{amount}}',
      players: '{{count}} ladri',
      team: 'La banda',
      ready: 'Pronto',
      waiting: 'Aspetto gli altri',
      skip: 'Il briefing finisce quando sono tutti pronti.',
    },
    planning: {
      title: 'La pianta',
      proposal: 'La proposta',
      notVoted: 'ci pensa',
      yes: 'sì',
      no: 'no',
      approve: 'Approva',
      reject: 'Boccia',
      tie: 'Parità. Decidi tu.',
      revise: 'Rivedi',
      waitingTie: 'Parità: decide la Mente.',
      rejected: 'Bocciato {{count}} volta/e. Arriva un nuovo piano.',
      waiting: 'La {{who}} sta preparando il piano.',
      entrance: 'Ingresso',
      route: 'Percorso',
      alcoves: 'Alcove',
      gear: 'Kit',
      none: 'nessuna',
      estimate: 'Lavoro e tempo',
      estimateValue: 'circa {{work}} di lavoro contro {{timer}} sull’orologio',
      stamp: 'Approvato',
      build: 'Disegna il piano',
      howTo:
        'Tocca le stanze per allungare il percorso fino al caveau; tocca una stanza già sul percorso per accorciarlo; tocca un’alcova tratteggiata per aggiungerla.',
      pickEntrance: 'Scegli un ingresso per cominciare.',
      gearTitle: 'Kit {{spent}} / {{budget}}',
      propose: 'Proponi il piano',
      clear: 'Ricomincia',
      suggest: 'L’idea dei bot',
    },
    feed: { title: 'La linea' },
    route: {
      label: 'Il piano',
      corridor: 'corridoio verso {{room}}',
      rope: 'salto a fune',
      back: 'ritorno da {{room}}',
      escape: 'Fuga',
    },
    heist: {
      puzzles: 'Rompicapi di questa stanza',
      moving: 'La squadra si sposta nella stanza successiva.',
    },
    power: {
      title: 'Poteri',
      planB: 'Piano B (ne restano {{count}})',
      drone: 'Manda il drone',
      skip: 'Salta la prossima alcova',
      loop: 'Loop alle telecamere (ne restano {{count}})',
      mole: 'Gli attrezzi della Talpa',
    },
    sabotage: {
      tamper: 'Manomette un indizio',
      tipoff: 'Soffiata alle guardie',
      rush: 'Pattuglia in anticipo',
    },
    phrases: { open: 'Dì qualcosa', pings: 'Ping', say: 'Dillo', param: 'Valore {{n}}' },
    ping: { here: 'Qui', danger: 'Pericolo', wait: 'Aspetta', go: 'Vai' },
    escapeSides: { left: 'sinistra', right: 'destra', top: 'alto', bottom: 'basso' },
    errors: {
      generic: 'Non ha funzionato.',
      gameOver: 'La partita è finita.',
      wrongPhase: 'Non ora.',
      notAllowed: 'Non tocca a te.',
      invalid: 'Non è permesso.',
      unknownPuzzle: 'Rompicapo inesistente.',
      puzzleNotActive: 'La squadra non è ancora lì.',
      puzzleSolved: 'Già risolto.',
      illegalMove: 'Mossa impossibile.',
      noCharges: 'Non ne restano.',
      cooldown: 'Troppo presto.',
      nothingToDo: 'Non c’è niente da fare lì.',
      tooLate: 'Troppo tardi.',
    },
    puzzle: {
      say: 'Dillo',
      heard: 'Cosa ti hanno detto',
      heardNone: 'Ancora niente. Chiedi agli altri.',
      bystander:
        'Il rompicapo «{{puzzle}}» è dell’altro ruolo ({{role}}). Puoi comunque aiutare con frasi e ping.',
      solved: 'Risolto',
      yours: 'Tocca a te',
      done: 'Fatto.',
      useGear: 'Usa {{gear}}',
      lock: {
        progress: 'Perni a posto: {{done}} su {{total}}',
        pins: 'Perni',
        set: 'Perno {{pin}} all’altezza {{height}}',
        vibrates: 'Il perno {{pin}} vibra: perno giusto, altezza sbagliata.',
        falls: 'Il perno {{pin}} ricade.',
        orderHint: 'I perni vanno in questo ordine. Di’ allo Scassinatore qual è il prossimo.',
        heightsHint: 'L’altezza di ogni perno. Dilla allo Scassinatore quando te la chiede.',
      },
      safe: {
        left: 'Tentativi rimasti: {{count}}',
        repeats: 'le cifre possono ripetersi',
        distinct: 'le cifre sono tutte diverse',
        keypad: 'Tastierino',
        erase: 'Cancella',
        jammed: 'Inceppata',
        try: 'Prova',
        answer: '{{clicks}} clic, {{hums}} ronzii',
        profileHint: 'Il profilo del proprietario. Ogni riga è vera. Leggile allo Scassinatore.',
      },
      panel: {
        serial: 'Numero di serie',
        done: 'Fatto',
        cut: 'Taglia',
        connect: 'Collega',
        manualHint:
          'Il manuale del quadro, regola per regola. Per ogni cavo decide la prima regola che calza.',
      },
      cameras: {
        board: 'Griglia delle telecamere',
        camera: 'La telecamera {{n}} guarda a {{dir}}',
        turn: 'Gira la telecamera {{n}}',
        locked: 'Rete bloccata',
        verify: 'Controlla',
        pathHint:
          'Il percorso delle guardie (numerato) e le telecamere. Di’ all’Hacker dove non deve guardare ciascuna.',
        pathBoard: 'Percorso delle guardie',
      },
      laser: {
        hint: 'Tocca uno specchio per girarlo, poi spara. Il raggio deve arrivare al ricevitore ed evitare la teca.',
        board: 'Stanza del laser',
        mirror: 'Specchio {{n}}, {{orient}}',
        fire: 'Spara',
        recharging: 'In ricarica',
        previewHint:
          'Dove va il raggio con gli specchi come sono adesso. Di’ allo Scassinatore cosa girare.',
        preview: 'Anteprima del raggio',
        end: {
          receiver: 'Il raggio arriva al ricevitore.',
          case: 'Il raggio colpisce la teca.',
          obstacle: 'Il raggio si ferma contro un ostacolo.',
          edge: 'Il raggio esce dalla stanza.',
          loop: 'Il raggio gira in tondo.',
        },
      },
      password: {
        left: 'Tentativi rimasti: {{count}}',
        locked: 'Il terminale è bloccato per un momento.',
        clueHint: 'Quello che sai sulla parola. Leggilo all’Hacker.',
      },
      corridor: {
        round: 'Round {{n}}',
        board: 'Corridoio',
        move: 'Muovi',
        north: 'Su',
        south: 'Giù',
        east: 'Destra',
        west: 'Sinistra',
        stay: 'Fermo',
        waiting: 'Aspetto gli altri.',
        coin: 'Moneta ({{count}})',
        petard: 'Petardo ({{count}})',
        aim: 'Tocca una casella.',
        radarHint: 'Il radar: dove va ora ogni guardia. Dillo prima che tutti si muovano.',
      },
      escape: {
        yours: 'Guidi tu. Tocca un blocco e fallo scorrere. Libera l’auto (★).',
        watch: 'Guida la {{who}}. Guarda la griglia e di’ quello che vedi.',
        moves: 'Mosse: {{n}}',
        board: 'Parcheggio',
        car: 'Auto della fuga',
        police: 'Auto della polizia {{n}}',
        block: 'Blocco {{n}}',
        slide: 'Scorri',
        radio: 'Radio: un’auto della polizia da {{side}} tra {{when}}.',
      },
      vault: {
        errors: 'Codici errati: {{n}} su {{max}}',
        locked: 'bloccato',
        mine: 'I tuoi simboli',
        theirs: 'I suoi simboli',
        code: 'Il codice',
        slot: 'Posizione {{n}}: {{symbol}}',
        empty: 'vuota',
        symbols: 'Simboli',
        confirm: 'Conferma il codice',
        unconfirm: 'Ritira la mia conferma',
        sayConfirm: 'Di’ «confermo»',
        in: 'dentro',
        waiting: 'in attesa',
      },
    },
    events: {
      ping: {
        here: '{{who}}: qui.',
        danger: '{{who}}: pericolo!',
        wait: '{{who}}: aspetta.',
        go: '{{who}}: vai!',
      },
      notice: {
        suspiciousGuard: 'Una guardia sembra sospettosa.',
        interference: 'Interferenza sulla linea.',
        patrolEarly: 'La pattuglia è in anticipo!',
      },
      glitch: 'Il tuo terminale ha un’incertezza.',
      alarm: 'Allarme +{{delta}} → {{total}} %',
      police: 'La polizia sta arrivando: l’orologio corre più veloce.',
      alcovesClosed: 'Le alcove si sono sigillate.',
      solved: '{{puzzle}} risolto.',
      roomCleared: '{{room}} è libera.',
      entering: 'Dentro: {{room}}.',
      corridor: 'Un corridoio sorvegliato.',
      skipped: '{{room}} saltata.',
      rope: 'Un salto sulla fune.',
      sighted: 'Una guardia ha visto qualcuno!',
      planProposed: 'C’è un piano sul tavolo.',
      planVote: 'Voto: {{yes}} a favore, {{no}} contro.',
      planApproved: 'Piano approvato.',
      planRejected: 'Piano bocciato.',
      planTie: 'Parità.',
      started: 'L’orologio corre.',
      escape: 'Il caveau è aperto. Scappate!',
      radio: 'Radio: un’auto della polizia da {{side}}.',
      reinforcement: 'Un’auto della polizia blocca il parcheggio.',
      bulletin: 'Radio: «{{kind}}»',
      gearUsed: '{{gear}} usato.',
      disguise: 'Il travestimento vi ha salvati.',
      loop: 'Le telecamere sono in loop.',
      planB: 'Piano B: l’ultimo errore non è mai successo.',
      tunnel: 'Una galleria: radar, radio e telecamere tacciono.',
      failed: {
        alarm: 'L’allarme è al 100 %. Il colpo è perso.',
        time: 'Tempo scaduto. Il colpo è perso.',
        vault: 'Il caveau è bloccato per sempre. Il colpo è perso.',
      },
      completed: 'Siete arrivati al covo.',
      expelled: '{{who}} è fuori.',
      nobodyOut: 'Nessuno è fuori.',
      splitProposed: '{{who}} propone una spartizione.',
      splitApproved: 'La spartizione è approvata.',
      splitRejected: 'La spartizione è bocciata.',
      splitEqual: 'Troppi rifiuti: parti uguali.',
    },
    hideout: {
      stage: {
        discussion: 'Discussione',
        accusation: 'Accusa',
        split: 'La spartizione',
      },
      intro: {
        discussion:
          'Il bottino è sul tavolo. Parlate, e appuntate la puntina su chi vi convince meno.',
        accusation: 'Voto segreto. La maggioranza butta fuori uno di voi. O nessuno.',
        split: 'La Mente propone le quote; serve la maggioranza.',
      },
      board: 'La lavagna dei sospetti',
      pinsOn: '{{count}} puntina/e',
      pin: 'Appunta',
      unpin: 'Togli',
      accuse: 'Chi è la Talpa?',
      out: 'Sei fuori.',
      voteCast: 'Il tuo voto è registrato.',
      accusePlayer: 'Accusa {{name}}',
      nobody: 'Nessuno',
      voted: 'Hanno votato in {{count}} su {{total}}.',
      splitYours: 'La tua spartizione',
      total: 'Totale: {{total}} %',
      propose: 'Proponi',
      equalSplit: 'Parti uguali',
      splitTitle: 'La spartizione',
      proposer: 'Propone {{name}}.',
      rejections: 'Rifiutata {{count}} volta/e.',
      accept: 'Accetto',
      refuse: 'Rifiuto',
      waitingVotes: 'Aspetto i voti.',
      waitingProposal: 'Aspetto la proposta.',
    },
    reveal: {
      waiting: 'Il cinegiornale si sta caricando…',
      success: 'Il colpo è riuscito',
      failed: {
        alarm: 'L’allarme ha chiamato la polizia',
        time: 'Il tempo è scaduto',
        vault: 'Il caveau si è bloccato per sempre',
      },
      youWon: 'Hai vinto.',
      youLost: 'Hai perso.',
      infiltrator: 'La Talpa era {{name}}.',
      noInfiltrator: 'Non c’era nessuna Talpa.',
      expelled: '{{name}} è stato votato fuori.',
      loot: 'Il bottino',
      base: 'Bersaglio',
      extras: 'Alcove',
      penalty: 'Allarme al {{alarm}} %',
      total: 'Totale',
      nothing: 'Niente. Il piano prometteva {{planned}}.',
      scores: 'Vincitori e quote',
      mole: 'Talpa',
      winner: 'Vince',
      score: '{{amount}}',
      timeline: 'Cosa è successo davvero',
      noEvents: 'Non è successo nulla di strano.',
      sabotage: '{{who}} ha sabotato: {{what}}',
      chance: 'Caso: {{what}}',
      headline: {
        moleCaught: 'L’ispettore smaschera {{name}}',
        moleFree: '{{name}}, la Talpa, sfugge alla giustizia',
        innocentOut: 'Un innocente finisce fuori: {{name}}',
        noMole: 'Nessun traditore tra i ladri',
      },
      reel: 'Cinegiornale del Notturno',
      again: 'Gioca ancora',
      menu: 'Torna al menu',
    },
  },
  training: {
    title: 'Allenamento',
    intro:
      'Un rompicapo alla volta, contro il tempo. Tutto quello che ti direbbe la squadra è sul tavolo.',
    puzzle: 'Rompicapo',
    level: 'Livello',
    levelOption: 'Livello {{n}}',
    levelHint:
      'Più sale il livello, più grandi le griglie, più numerose le guardie, più lunghi i codici.',
    solver: 'Lo risolve {{role}}',
    par: 'Tempo di riferimento {{time}}',
    record: 'Record: {{time}}',
    noRecord: 'Nessun record',
    board: {
      title: 'I tempi più veloci',
      hint: 'Il miglior tempo di ogni giocatore in questo rompicapo e livello. Gli ospiti non compaiono.',
      empty: 'Qui nessuno ha ancora un tempo. Il tuo potrebbe essere il primo.',
      failed: 'Non si è potuta caricare la classifica.',
      guest: 'Trasforma il tuo account ospite in uno vero per mettere i tuoi tempi in classifica.',
      signIn: 'Accedi per vedere i tempi più veloci e mettere i tuoi in classifica.',
      you: 'tu',
    },
    starsLabel: '{{count}} stelle su 3',
    start: 'Via',
    hudTitle: '{{puzzle}} · livello {{level}}',
    yours: 'Il tuo rompicapo',
    team: 'Cosa sanno gli altri',
    teamHint: 'Nel colpo è sui loro schermi. Tocca «Dillo» per riferirlo, come farebbero loro.',
    teamNothing: 'Nessun altro ha indizi su questo.',
    timeLeft: 'Tempo rimasto',
    verdict: {
      won: 'Risolto',
      time: 'Tempo scaduto',
      alarm: 'È scattato l’allarme',
      vault: 'Il caveau si è bloccato',
    },
    result: {
      time: 'Tempo',
      par: 'Riferimento',
      errors: 'Errori',
      alarm: 'Allarme',
      stars: 'Stelle',
      newRecord: 'Nuovo record!',
    },
    again: 'Riprova',
    another: 'Un altro rompicapo',
    menu: 'Torna al menu',
  },
  tutorial: {
    title: 'Tutorial',
    intro:
      'Cinque colpi brevi alla Banca del Notturno, un ruolo alla volta. I bot fanno gli altri, con pazienza, e un istruttore ti spiega che cosa hai sullo schermo.',
    chapter: 'Capitolo {{n}}',
    done: 'Fatto',
    start: 'Inizia',
    replay: 'Rigioca',
    chapters: {
      c1: {
        title: 'Lo Scassinatore',
        lesson: 'Imposta i perni di una serratura come ti dicono i compagni.',
      },
      c2: {
        title: 'L’Hacker',
        lesson: 'Taglia i fili di un quadro elettrico e orienta le telecamere.',
      },
      c3: { title: 'La Mente', lesson: 'Disegna il piano, vinci il voto e guida la cassaforte.' },
      c4: { title: 'Il Palo', lesson: 'Sorveglia le guardie e porta la squadra in un corridoio.' },
      c5: { title: 'L’Autista', lesson: 'Apri il caveau, guida la fuga e affronta il covo.' },
    },
    coach: { title: 'Istruttore', gotIt: 'Capito', show: 'Mostra il consiglio' },
    complete: {
      title: 'Capitolo {{n}} completato',
      body: 'Hai imparato a cosa serve questo ruolo. Continua lo stesso colpo, oppure vai avanti.',
      bodyLast: 'Era l’ultimo capitolo. Ora conosci tutti i ruoli.',
      next: 'Capitolo successivo',
      keep: 'Continua a giocare',
      menu: 'Torna ai capitoli',
    },
    tips: {
      briefing: {
        c1: 'Sei lo Scassinatore. Le tue mani sono lo strumento: apri serrature, scassini casseforti e giri gli specchi del laser. Non vedi mai i segreti, te li dicono i compagni. Leggi la tua carta e tocca Pronto.',
        c2: 'Sei l’Hacker. Lavori su quadri elettrici, telecamere e password, e hai tre Loop per accecare le telecamere per un po’. Non hai mai tutta la verità: te la dicono gli altri. Leggi la tua carta e tocca Pronto.',
        c3: 'Sei la Mente. Vedi tutta la pianta, disegni il piano e hai i numeri che servono agli altri: le altezze della serratura, il profilo del proprietario della cassaforte. Leggi la tua carta e tocca Pronto.',
        c4: 'Sei il Palo. Solo tu vedi il radar delle guardie e hai il manuale del quadro e i percorsi delle telecamere. Leggi la tua carta e tocca Pronto.',
        c5: 'Sei l’Autista. Apri il caveau con gli altri, poi guidi la fuga. Leggi la tua carta e tocca Pronto.',
      },
      vote: 'La Mente ha messo un piano sul tavolo: un ingresso, le stanze in ordine, il kit. Guardalo sulla pianta e approvalo. Un piano bocciato costa tempo.',
      build:
        'Il piano lo disegni tu. Scegli un ingresso, poi tocca le stanze da lì fino al Caveau (la stella). Confronta la stima con l’orologio. Tocca «L’idea dei bot» per un piano che passa dagli Sportelli, dove c’è una cassaforte, poi premi Proponi.',
      voting: 'Il piano è sul tavolo. I compagni votano: basta la maggioranza.',
      wait: 'Questo tocca a un altro. Resta pronto: puoi sempre aiutare con «Dì qualcosa».',
      lock: 'Una serratura a perni. Ogni perno va a una certa altezza e vanno impostati in ordine. L’ordine lo sa l’Hacker, le altezze la Mente, tu non sai né l’uno né l’altro: ascolta la linea, poi tocca l’altezza sotto il perno. Una mossa sbagliata alza l’allarme. Se ti è sfuggito qualcosa, chiedi: «Dì qualcosa».',
      panel:
        'Un quadro elettrico. Ogni filo si taglia o si collega secondo un manuale che non è sul tuo schermo: con tre giocatori ce l’ha la Mente, altrimenti il Palo. Chiedi le regole e il numero di serie con «Dì qualcosa», poi agisci filo per filo.',
      cameras:
        'Le telecamere. Gira ognuna lontano dal percorso delle guardie, poi premi Verifica. Il percorso è sullo schermo di un altro: chiedilo. Finché le telecamere sono accese, l’allarme sale piano piano.',
      laser:
        'Una griglia laser. Lo Scassinatore gira gli specchi, tu vedi dove va il raggio. Di’ dove finisce e quale specchio girare.',
      safe: 'Una cassaforte. Hai il profilo del proprietario: di’ quello che sai con le frasi rapide. Lo Scassinatore prova le combinazioni e la cassaforte risponde con scatti e ronzii.',
      help: 'Qui non c’è niente per te. Il tuo Piano B può annullare l’ultimo errore, e le frasi rapide tengono la squadra allineata.',
      manual:
        'Quadro e telecamere li fa l’Hacker, ma il manuale e i percorsi delle guardie sono tuoi. Diglieli: «Dì qualcosa», poi scegli la frase.',
      corridor:
        'Un corridoio sorvegliato. Tutti si muovono di un passo alla volta e le guardie fanno la ronda. Solo il tuo radar mostra tutta la ronda: di’ agli altri dove aspettare e quando andare. Usa una Moneta o il Petardo per attirare una guardia.',
      vault:
        'Il caveau. I cinque simboli del codice sono divisi tra voi: di’ i tuoi, raccogli quelli degli altri, inserisci il codice e fatelo confermare a tutti. Tre codici sbagliati lo bloccano per sempre.',
      escape:
        'La fuga. Guidi tu: fai scorrere i blocchi per liberare l’auto. La radio della polizia annuncia le auto da sinistra o da destra: riferiscilo alla squadra.',
      hideout:
        'Il covo. Parlate, appuntate i sospetti, votate e dividete il bottino. Nel tutorial non c’è nessun traditore, quindi puoi solo fare pratica.',
    },
  },
  phrases: {
    names: {
      ready: 'Pronto',
      wait: 'Aspetta',
      go: 'Vai',
      danger: 'Pericolo',
      needRole: 'Mi serve…',
      done: 'Fatto',
      repeat: 'Ripeti',
      dontKnow: 'Non lo so',
      lockPinHeight: 'Altezza del perno',
      lockNextPin: 'Perno successivo',
      safeDigit: 'La cifra è…',
      safeClue: 'Il codice contiene',
      safeNo: 'Il codice non ha',
      safeSum: 'Somma delle cifre',
      safeParity: 'Cifra pari / dispari',
      safeGreater: 'Cifra maggiore di',
      safeAttempt: 'Il mio tentativo',
      panelSerial: 'Numero di serie',
      panelWire: 'Azione sul cavo',
      panelRule: 'Regola del manuale',
      panelRuleLetter: 'Regola del manuale (lettera)',
      camAvoid: 'Telecamera: evita',
      camNow: 'Telecamera guarda',
      laserMirror: 'Specchio',
      laserEnds: 'Il raggio finisce',
      passClue: 'Indizio parola',
      passTry: 'Provo la parola',
      corGuard: 'La guardia va',
      corHold: 'Fermo',
      corShadow: 'Ombra a',
      escReinforce: 'Rinforzi',
      escMove: 'Sposta il blocco',
      vaultPos: 'Posizione del caveau',
      vaultConfirm: 'Confermo',
      bulletin: 'Bollettino radio',
      suspect: 'Sospetto di',
      trust: 'Mi fido di',
      sawWeird: 'Il mio terminale ha un’incertezza',
    },
    ready: 'Pronto.',
    wait: 'Aspetta.',
    go: 'Vai!',
    danger: 'Pericolo!',
    needRole: 'Mi serve: {{p1}}.',
    done: 'Fatto.',
    repeat: 'Ripeti?',
    dontKnow: 'Non lo so.',
    lockPinHeight: 'Perno {{p1}}: altezza {{p2}}.',
    lockNextPin: 'Il prossimo è il perno {{p1}}.',
    safeDigit: 'La cifra {{p1}} è {{p2}}.',
    safeClue: 'Il codice contiene un {{p1}}.',
    safeNo: 'Il codice non ha nessun {{p1}}.',
    safeSum: 'Le cifre sommano {{p1}}.',
    safeParity: 'La cifra {{p1}} è {{p2}}.',
    safeGreater: 'La cifra {{p1}} è maggiore della cifra {{p2}}.',
    safeAttempt: 'Provato {{p1}}: {{p2}} clic, {{p3}} ronzii.',
    panelSerial: 'Il numero di serie finisce con {{p1}}.',
    panelWire: 'Cavo {{p1}}: {{p2}}.',
    panelRule_color: 'Regola {{p1}}: cavo {{p3}} → {{p4}}.',
    panelRule_odd: 'Regola {{p1}}: cavo {{p3}}, serie che finisce dispari → {{p4}}.',
    panelRule_even: 'Regola {{p1}}: cavo {{p3}}, serie che finisce pari → {{p4}}.',
    panelRule_first: 'Regola {{p1}}: primo cavo → {{p4}}.',
    panelRule_last: 'Regola {{p1}}: ultimo cavo → {{p4}}.',
    panelRule_twoPlus: 'Regola {{p1}}: due o più cavi {{p3}} → {{p4}}.',
    panelRuleLetter: 'Regola {{p1}}: cavo {{p2}}, lettera {{p3}} nel numero di serie → {{p4}}.',
    camAvoid: 'Telecamera {{p1}}: non guardare a {{p2}}.',
    camNow: 'La telecamera {{p1}} guarda a {{p2}}.',
    laserMirror: 'Specchio {{p1}}: {{p2}}.',
    laserEnds: 'Il raggio finisce in {{p1}}, {{p2}}.',
    passClue_category: 'Indizio parola: è un tipo «{{p2}}».',
    passClue_first: 'Indizio parola: comincia con {{p2}}.',
    passClue_last: 'Indizio parola: finisce con {{p2}}.',
    passClue_contains: 'Indizio parola: contiene {{p2}}.',
    passClue_excludes: 'Indizio parola: non ha {{p2}}.',
    passTry: 'Provo la parola {{p1}}.',
    corGuard: 'La guardia {{p1}} va a {{p2}}.',
    corHold: '{{p1}}: fermo.',
    corShadow: 'Ombra in {{p1}}, {{p2}}.',
    escReinforce: 'Rinforzi da {{p1}} tra {{p2}} s.',
    escMove: 'Sposta il blocco {{p1}}.',
    vaultPos: 'La posizione {{p1}} è {{p2}}.',
    vaultConfirm: 'Confermo.',
    bulletin: 'Radio: aspettatevi «{{p1}}».',
    suspect: 'Sospetto di {{p1}}.',
    trust: 'Mi fido di {{p1}}.',
    sawWeird: 'Il mio terminale ha avuto un’incertezza.',
    enum: {
      n: 'nord',
      ne: 'nord-est',
      e: 'est',
      se: 'sud-est',
      s: 'sud',
      sw: 'sud-ovest',
      w: 'ovest',
      nw: 'nord-ovest',
      red: 'rosso',
      blue: 'blu',
      yellow: 'giallo',
      black: 'nero',
      white: 'bianco',
      green: 'verde',
      any: 'qualsiasi',
      cut: 'taglia',
      connect: 'collega',
      leave: 'lascia stare',
      even: 'pari',
      odd: 'dispari',
      slash: '/',
      backslash: '\\',
      left: 'sinistra',
      right: 'destra',
      top: 'alto',
      bottom: 'basso',
      mastermind: 'Mente',
      locksmith: 'Scassinatore',
      hacker: 'Hacker',
      lookout: 'Palo',
      driver: 'Autista',
      suspiciousGuard: 'una guardia sospettosa',
      interference: 'interferenza sulla linea',
      patrolEarly: 'pattuglia in anticipo',
      color: 'colore',
      first: 'primo',
      last: 'ultimo',
      twoPlus: 'due o più',
      category: 'categoria',
      contains: 'contiene',
      excludes: 'esclude',
    },
    categories: { '0': 'luogo', '1': 'attrezzo', '2': 'persona', '3': 'refurtiva', '4': 'vizio' },
    symbols: {
      '0': 'picche',
      '1': 'cuori',
      '2': 'quadri',
      '3': 'fiori',
      '4': 'stella',
      '5': 'luna',
      '6': 'sole',
      '7': 'àncora',
    },
  },
};
